import { render, staticRenderFns } from "./PanBL.vue?vue&type=template&id=15d1ba05&scoped=true"
import script from "./PanBL.vue?vue&type=script&lang=js"
export * from "./PanBL.vue?vue&type=script&lang=js"
import style0 from "./PanBL.vue?vue&type=style&index=0&id=15d1ba05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d1ba05",
  null
  
)

export default component.exports